var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("블루월넛 결제 "),_c('p',[_c('tt',{attrs:{"id":"results1"}})],1),_c('p',[_c('tt',{attrs:{"id":"results2"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }